import angular from 'angular';

/**
 * @ngdoc overview
 * @name superuserModule.packagesServices
 * @description
 * # superuserModule.packagesServices
 * Module for managing the services of: client packages. For $http requests, API calls.
 */
const packagesServices = angular.module('superuserModule.packagesServices', []);

/**
 * @ngdoc interface
 * @name superuserModule.packagesServices.interface:PackageAPI
 * @description
 * Service for handling API connections for: Packages.
 */
packagesServices.factory('Package', ['$http', 'AppsoupAPI', ($http, AppsoupAPI) => {
    'use strict';

    const API_URL = `${AppsoupAPI.API_URL}/package/`;

    return {
        getList: (params) => {
            const tableParams = AppsoupAPI.getTableParams(params);

            return $http.get(API_URL, {params: tableParams})
                .then(response => response.data.packages.data);
        },
        get: (packageId) => $http.get(`${API_URL}${packageId}`),
        save: (clientPackage, editMode) => {
            if (editMode) {
                return $http.put(`${API_URL}${clientPackage.id}`, clientPackage);
            } else {
                return $http.post(API_URL, clientPackage);
            }
        },
        remove: (packageId) => $http.delete(`${API_URL}${packageId}`)
    };
}]);

export default packagesServices;
